import { render, staticRenderFns } from "./RegistrationFormSms.vue?vue&type=template&id=1d3edd3c&scoped=true"
import script from "./RegistrationFormSms.vue?vue&type=script&lang=js"
export * from "./RegistrationFormSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3edd3c",
  null
  
)

export default component.exports